import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { CtAdminConfigRow, CtConfigRow } from 'containers';
import { Label, Icon } from 'semantic-ui-react';

import * as commonVar from 'libs/commonVar';

import classNames from 'classnames/bind';
import styles from './ConfigClass.css';
const cx = classNames.bind(styles);

const ConfigClass = ({ isAuth, classTitle, classChild, ...rest }) => {
  const childDom = [];
  for (let i = 0; i < classChild.length; i++) {
    const parameter = classChild[i].parameter;
    const parameterNotice = classChild[i].parameterNotice;
    // GS 인증 숨김 처리
    if (
      (commonVar.isGs === 1 &&
        (parameter === 'includeAlphabet' ||
          parameter === 'includeNumeric' ||
          parameter === 'includeSpecialChar' ||
          parameter === 'AdminAccessAllowIp' ||
          parameter === 'sessionTimeout' ||
          parameter === 'allowLoginFailCount' ||
          parameter === 'examMailSendRetry' ||
          parameter === 'mailId' ||
          parameter === 'mailPassword')) ||
      // 다음에 변경주기는 제외
      parameter === 'passwordChangeNotifyPeriod'
    ) {
      //
    } else {
      if (isAuth === 2) {
        childDom.push(
          <CtAdminConfigRow
            key={'configSmtpRow' + i + classTitle}
            paramKey={parameter}
            parameterNotice={parameterNotice}
            {...rest}
          />
        );
      } else {
        childDom.push(
          <CtConfigRow
            key={'configSmtpRow' + i + classTitle}
            paramKey={parameter}
            parameterNotice={parameterNotice}
            {...rest}
          />
        );
      }
    }
  }

  // GS일때 항목 제거
  if (commonVar.isGs === 1 && (classTitle === 'exam' || classTitle === 'login')) {
    return false;
  }

  return (
    <div className={cx('config-class')}>
      <div className={cx('config-class-top')}>
        <Label className={cx('config-class-title')}>{classTitle}</Label>
      </div>
      <div className={cx('config-class-box')}>{childDom}</div>
    </div>
  );
};

ConfigClass.propTypes = {
  classTitle: PropTypes.string.isRequired,
  classChild: PropTypes.array.isRequired
};
ConfigClass.defaultProps = {
  classTitle: '',
  classChild: []
};

export default ConfigClass;



// WEBPACK FOOTER //
// ./src/script/components/config/ConfigClass.js